module.exports = __webpack_public_path__ + "media/src/images/zu_05keep_rules04-74a609c59c242052c466a4a695dd0f1f.gif";